import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
// import { getEnvUrl } from '../utils/getEnvUrl';
import Spinner from '../components/common/spinner';

@inject('settingsStore')
@observer
class ClosePopup extends Component {
  render() {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
}

export default ClosePopup;
